import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { LoadingButton, LoadingComponent } from "usbc-web-react-library";
import { Document, Page, pdfjs } from "react-pdf";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import useManageApi from "../../hooks/useManageApi";
import ValidationErrors from "../shared/ValidationErrors";
import "./CertificateView.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
const CertificateView = () => {
    const { viewSafeSportCertificate, loading: viewSafeSportCertificateLoading, error: viewCeritificateError } = useManageApi();
    const { downloadSafeSportCertificate, loading: downloadSafeSportCertificateLoading } = useManageApi();
    const [certificateUrl, setCertificateUrl] = useState(null);
    const [currentCertificateName, setCurrentCertificateName] = useState(null);
    const [hideButtons, setHideButtons] = useState(true);
    const [validationErrors, setValidationErrors] = useState([]);
    const navigate = useNavigate();

    const file = useMemo(() => ({ url: certificateUrl }), [certificateUrl]);

    useEffect(() => {
        viewSafeSportCertificate({
            params: getUrlParams(),
            onError: (errors) => {
                setValidationErrors(errors);
            }
        }).then(
            (result) => {
                setCertificateUrl(result);
            }
        )
    }, []);

    useEffect(()=>{
        setValidationErrors(viewCeritificateError);
    },[viewCeritificateError]);

    function getUrlParams(){
        const currentUrl = new URL(window.location.href);
        const currentUrlParams = currentUrl.searchParams;
        const pdfName = currentUrlParams.get('pdfName');
        let urlParams = {};
        if (pdfName) {
            urlParams = { ...urlParams, pdfName: pdfName };
            setCurrentCertificateName(pdfName);
        }
        return urlParams;
    }

    function goBackHandler(){
        navigate('/Certificates');
    };

    function downloadSafeSportCertificateHandler() {
        downloadSafeSportCertificate({ params: getUrlParams() });
    }

    function printCertificate() {
        var iframe =  document.createElement('iframe'); //load content in an iframe to print later
        document.body.appendChild(iframe);

        iframe.style.display = 'none';
        iframe.src = certificateUrl;
        iframe.onload = function() {
        setTimeout(function() {
            iframe.focus();
            iframe.contentWindow.print();
        }, 1);
        };
    }

    return (
        <>
            {<div>
                <h4>{currentCertificateName}</h4>
                <LoadingComponent isLoading={() => viewSafeSportCertificateLoading} description="Loading Certificate... Please Wait.">
                    {certificateUrl && 
                        <Document file={file} className="certificateView-pdf-view" 
                            onLoadSuccess={()=>{setHideButtons(false);}}
                            error={
                                <div className="alert alert-danger">Failed to render PDF. Try downloading the certificate. If the issue persists, please contact support.</div>
                            }>
                            <Page pageNumber={1}></Page>
                        </Document>}
                    {!certificateUrl &&
                        <ValidationErrors className="validation-errors alert alert-danger mt-3" validationErrors={validationErrors}/>
                    }
                </LoadingComponent>
                <div style={{ width: "100%" }} className="justify-content-end d-flex mt-3">
                    <div className="btn-toolbar d-grid gap-2 d-lg-block" role="toolbar">
                        <div className="btn-group me-2">
                            <button className="btn-primary btn" onClick={goBackHandler}>
                                Go Back to Certificates
                            </button>
                        </div>
                        <div className="btn-group me-2">
                            
                            <LoadingButton className="btn-success bg-usbc-green btn" onClick={printCertificate} 
                                loadingText='Preparing...' loading={viewSafeSportCertificateLoading} disabled={hideButtons}>
                            <i className="bi bi-printer"></i>
                            <span className='ms-2'>Print Certificate</span>
                            </LoadingButton>
                        </div>
                        <div className="btn-group me-2">
                            <LoadingButton className="btn btn-success bg-usbc-green me-md-1" onClick={downloadSafeSportCertificateHandler}
                               loadingText='Downloading...' loading={downloadSafeSportCertificateLoading}>
                                <i className="bi bi-download"></i>
                                <span className='ms-2'>Certificate Download</span>
                            </LoadingButton>
                        </div>
                    </div>
                </div>
            </div>
            }
        </>
    )
}

export default CertificateView;